/*
https://github.com/ngx-formly/ngx-formly/issues/2021
*/

import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-count-chars-wrapper',
  template: `
    <div class="d-flex flex-column">
      <ng-container #fieldComponent></ng-container>
      @if (to.maxLength) {
        <mat-hint class="d-flex justify-end items-end" style="user-select: none;">
          {{ formControl.value?.length || 0 }}/{{ to.maxLength }}
        </mat-hint>
      }
    </div>
  `,
  standalone: false,
})
export class FormlyCountCharsWrapperComponent extends FieldWrapper {}
